import { Environment } from './environment.model';
import { APP_VERSION } from './version';

export const environment: Environment = {
  production: true,
  BASE_URL: 'https://performance-qa-api.navtor.com',
  BASE_URL_V2: 'localhost',
  authExcludedUrls: ['/login'],
  nspUrl: undefined,
  appVersion: APP_VERSION,
};
